// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"123":"e89e99","534":"ca8b8e","599":"65b92d","621":"5d617f","976":"2e5524"}[chunkId] + ".js";
};